import { languageMap } from ".."
import { bracketIndenting } from "./shared"

languageMap.kusto = bracketIndenting({
	line: "//",
})
